import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createHttpLink, ApolloLink } from '@apollo/client';
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import { onError } from '@apollo/client/link/error';
import { addGqlRouteLink } from '@chegg-web-tools/apollo-utils';
import { rewriteCheggTldToMatch } from '@chegg/utils';
import crossFetch from 'cross-fetch';
import { print } from 'graphql';
import hash from 'hash.js';
import { createAuthLink } from './links/authLink';
import { createFetchPolicyLink } from './links/fetchPolicyLink';
import { handleApolloError } from './links/errorLink';
import { APOLLO_COMMERCE_CONTEXT, ONEGRAPH_URI_PROD, ONEGRAPH_URI_TEST } from './constants';
var getHttpLink = function getHttpLink(uri) {
  var httpLink = createHttpLink({
    credentials: 'include',
    fetch: crossFetch,
    fetchOptions: {
      credentials: 'include'
    },
    headers: _defineProperty(_defineProperty({}, 'Accept', 'application/json'), 'apollographql-client-name', '@chegg/commerce-utils'),
    uri: uri
  });
  var authLink = createAuthLink();
  var persistedQueryLink = createPersistedQueryLink({
    generateHash: function generateHash(d) {
      return hash.sha256().update(print(d)).digest('hex');
    }
  });
  var fetchPolicyLink = createFetchPolicyLink();
  return ApolloLink.from([authLink, fetchPolicyLink, onError(handleApolloError), persistedQueryLink, httpLink]);
};
var configured = false;

/**
 * Configure Apollo Client for the Commerce context.
 *
 * To consume, simply execute this function in your application. Then, when making commerce
 * queries through the Apollo Client, pass in the APOLLO_COMMERCE_CONTEXT, e.g.
 *
 * const { loading, error, data } = useQuery(QUERY, {
 *   context: {
 *     [APOLLO_COMMERCE_CONTEXT]: true,
 *   },
 * });
 */
var configureApolloForCommerce = function configureApolloForCommerce() {
  var isProd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var hostname = arguments.length > 1 ? arguments[1] : undefined;
  if (!configured) {
    var uri = rewriteCheggTldToMatch(isProd ? ONEGRAPH_URI_PROD : ONEGRAPH_URI_TEST, hostname);
    var httpLink = getHttpLink(uri);
    addGqlRouteLink(APOLLO_COMMERCE_CONTEXT, httpLink);
    configured = true;
  }
};
export var setConfigured = function setConfigured(value) {
  configured = value;
};
export default configureApolloForCommerce;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/gql/configureApolloForCommerce.js
// module id = 477
// module chunks = 11